import { MuiTheme, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = (props: { genreTab: boolean }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      mediaCenterContainer: {
        display: 'grid',
        [theme.breakpoints.down('sm')]: {
          display: 'none'
        }
      },
      mediaCenterHeaderText: {
        lineHeight: '1',
        fontSize: '40px',
        fontWeight: 600,
        letterSpacing: 'normal',
        [theme.breakpoints.down('sm')]: {
          fontSize: '36px'
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: '32px'
        },
        [theme.breakpoints.only('md')]: {
          fontSize: '36px'
        }
      },
      mediaCenterNotAvailable: {
        display: 'none',
        [theme.breakpoints.down('sm')]: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0px 10px'
        },
        [theme.breakpoints.only('sm')]: {
          padding: '0px 30px',
          height: 'calc(100vh - 104px)'
        },
        [theme.breakpoints.only('xs')]: {
          height: 'calc(100vh - 89px)'
        }
      },
      mediaNotAvailableMessage: {
        fontSize: '32px',
        lineHeight: '1.13',
        textAlign: 'center',
        [theme.breakpoints.only('xs')]: {
          fontSize: '24px'
        }
      },
      mediaCenterSelectorPills: {
        '& > * > button': {
          [theme.breakpoints.only('md')]: {
            width: props.genreTab ? '125px' : '169px'
          }
        }
      }
    })
  );
